import { writable } from 'svelte/store';
import { PUBLIC_FINANCEFY_URL } from '$env/static/public';
import logoPNM from '$lib/assets/images/logo.svg';
import logoFinancefy from '$lib/assets/images/logo-financefy.svg';
import logoFooterPNM from '$lib/assets/images/logo-footer.svg';
import logoFooterMobilePNM from '$lib/assets/images/logo-footer-mobile.svg';
import logoFooterFinancefy from '$lib/assets/images/logo-footer-financefy.svg';

let domain = {
	name: 'Poupança No Minuto',
	GTM: 'GTM-WP276P6',
	tagId: 'G-YJPR1FRSPV',
	OneSignalAppId: 'fa8c60fa-69f7-4bac-96fa-8b2682681a95',
	headerBackground: 'bg-white',
	headerColor: 'text-dark',
	buttonBackground: 'bg-primary',
	buttonColor: 'text-white',
	logo: logoPNM,
	logoFooter: logoFooterPNM,
	logoFooterMobile: logoFooterMobilePNM,
	footerLinks: {
		facebook: 'https://www.facebook.com/poupancanominuto',
		linkedin: 'https://www.linkedin.com/company/poupancanominuto/',
		whatsapp: false,
		instagram: 'https://www.instagram.com/poupancanominuto/',
		youtube: 'https://www.youtube.com/@poupancanominuto',
		tiktok: 'https://www.tiktok.com/@poupancanominuto'
	}
};
if (typeof window !== 'undefined' && window.location.hostname == PUBLIC_FINANCEFY_URL) {
	domain = {
		name: 'Financefy',
		GTM: 'GTM-K4MCTR8',
		tagId: 'G-WG406H8GP5',
		OneSignalAppId: 'a34ff7c1-6a7d-4dae-a8bd-76a6e58a4dfa',
		headerBackground: 'bg-financefy',
		headerColor: 'text-white',
		buttonBackground: 'bg-primary-light',
		buttonColor: 'text-financefy',
		logo: logoFinancefy,
		logoFooter: logoFooterFinancefy,
		logoFooterMobile: logoFooterFinancefy,
		footerLinks: {
			facebook: 'https://www.facebook.com/financefy.pt/',
			linkedin: 'https://www.linkedin.com/company/financefy/',
			whatsapp: false,
			instagram: 'https://www.instagram.com/financefy.pt',
			tiktok: 'https://www.tiktok.com/@poupancanominuto'
		}
	};
}
export default writable(domain);
